import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function GreetingList() {
  const navigate = useNavigate();
  const [greetingData, setGreetingData] = useState([]);
  const [deleteGiftId, setDeleteGiftId] = useState("");
  const [deleteTitle, setDeleteTitle] = useState("");
  const [dataTable, setDataTable] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (greetingData.length) {
      if (dataTable) {
        dataTable.destroy();
      }
      const table = $("#greeting").DataTable({
        data: greetingData,
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 },
          {
            data: "url",
            render: (data) =>
              `<div class="prodlist_img"><img src="${data}" alt="Product" border="0" /></div>`,
          },
          { data: "name" },
          {
            data: "category_details",
            render: (data) => {
              // Handle cases where category_details might be empty or malformed
              if (!data || !data[0] || !data[0][0]) return " ";

              // Map through all categories and join them with commas
              return data[0]
                .map((cat) => cat.category)
                .filter(Boolean)
                .join(", ");
            },
          },
          {
            data: "price",
            render: (data) => `₹${data}`,
          },
          {
            data: "created_date",
            render: (data) => new Date(data).toLocaleString(),
          },
          {
            data: null,
            render: (data) => {
              return `
                                <div align="center">
                                    <a href="/greetingcard_edit?id=${data._id}" class="crsr_pntr"><i class="fa-solid fa-pen mr-2"></i></a>
                                    <a href="#" class="crsr_pntr delete-btn" data-id="${data._id}" data-name="${data.name}" data-toggle="modal" data-target="#modaldelete"><i class="fa-solid fa-trash-can"></i></a>
                                </div>
                            `;
            },
          },
        ],
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50, 75, 100],
      });
      setDataTable(table);

      $("#greeting").on("click", ".delete-btn", function () {
        const productId = $(this).data("id");
        const productName = $(this).data("name");
        openDeleteModal(productId, productName);
      });
    }
  }, [greetingData]);

  const fetchData = () => {
    const businessId = localStorage.getItem("business_id");
    const signupStatus = localStorage.getItem("signup");
    let params = {};
    if (businessId && signupStatus === "user") {
      params.business_id = businessId;
    }
    axios
      .get(process.env.REACT_APP_APIURL + "greeting/list", { params })
      .then((res) => {
        if (res.data.status === "success") {
          setGreetingData(res.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching greeting data:", err);
      });
  };

  const deleteGift = (greeting_id) => {
    const businessId = localStorage.getItem("business_id"); // Get business_id from localStorage
    const signupStatus = localStorage.getItem("signup"); // Get signup status from localStorage

    // Prepare the API request payload
    let payload = {
      greeting_id: greeting_id,
      greeting_status: "delete",
    };

    // Check the condition based on business_id and signup
    if (businessId && signupStatus === "user") {
      payload.business_id = businessId; // Pass business_id if user is signed up
    }

    axios
      .post(`${process.env.REACT_APP_APIURL}greeting/delete`, payload)
      .then((res) => {
        if (res.data.status === "success") {
          setGreetingData(
            greetingData.filter((product) => product._id !== greeting_id)
          );
        }
      })
      .catch((err) => {
        console.error("Error deleting product:", err);
      });
  };

  const openDeleteModal = (id, title) => {
    setDeleteGiftId(id);
    setDeleteTitle(title);
  };

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  Greeting Card
                  <a href="/greetingcard_add">
                    <i
                      className="fa-solid fa-square-plus ml-2"
                      title="Add Product"
                    />
                  </a>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
              {greetingData.length === 0 ? (
                  <p>No records found.</p> // Display message if no data
                ) : (
                <div className="table-responsive">
                  <table
                    id="greeting"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Gift</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Price</th>
                        <th>Added On</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <div
        className="modal fade"
        id="modaldelete"
        tabIndex={-1}
        aria-labelledby="modaldeleteLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modaldeleteLabel">
                Delete Greeting Card
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body">
              <div className="w-100 d-inline-block text-center">
                Are you sure you want to delete <br />
                <span className="fwt_600">{deleteTitle}</span>?
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => deleteGift(deleteGiftId)}
              >
                Yes, delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                aria-label="Close"
              >
                No, cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GreetingList;
